module.exports = __webpack_public_path__ + "static/media/ei07.3a375a7f.png";